import { render, staticRenderFns } from "./VolunteersSearchResultList.vue?vue&type=template&id=1bc7e412"
import script from "./VolunteersSearchResultList.vue?vue&type=script&lang=js"
export * from "./VolunteersSearchResultList.vue?vue&type=script&lang=js"
import style0 from "./VolunteersSearchResultList.vue?vue&type=style&index=0&id=1bc7e412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports